// PEP.js is used for Babylon.js touch compatibility
import 'pepjs';
import Vue from 'vue';
import VueGtm from "vue-gtm";
import { VueHammer } from 'vue2-hammer';
import VueLogger from 'vuejs-logger';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

require('jspolyfill-array.prototype.find');

const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};

Vue.use(VueLogger, options);

Vue.use(VueHammer);

Vue.use(VueGtm, {
  id: "GTM-K4TSCB6",
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
});

Vue.config.ignoredElements = ['my-quizz'];

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// App["$log"] = Vue.$log;
store['$log'] = Vue.$log;
